module.exports = __webpack_public_path__ + "static/media/bn_wix_template.de63d3d8.png";